import { render } from "./Bar.vue?vue&type=template&id=bfa7e8b2&scoped=true&ts=true"
import script from "./Bar.vue?vue&type=script&lang=ts"
export * from "./Bar.vue?vue&type=script&lang=ts"

import "./Bar.vue?vue&type=style&index=0&id=bfa7e8b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa7e8b2"]])

export default __exports__